import { ReactNode } from "react";

export default function Group({
  children
}: {
  children: ReactNode;
}) {
  return (
    <>
      {children}
    </>
  );
}